// extracted by mini-css-extract-plugin
export default {"homepage":"Homepage_homepage__hZdMT","slideInUp":"Homepage_slideInUp__6sd+L","typing":"Homepage_typing__xsRyK","blink-caret":"Homepage_blink-caret__PPIJA"};